import { createAction } from '@reduxjs/toolkit';

import { moduleName } from '../constants';

export const rtkRefetchUnitEvents = createAction<{
  unitIds: Array<string | number>;
}>(`${moduleName}/RTK_REFETCH_UNIT_EVENTS`);

export const deleteRecurrentEventsResponse = createAction(
  `${moduleName}/DELETE_RECURRENT_EVENTS_RESPONSE`,
);

export const deleteEventsResponse = createAction(
  `${moduleName}/DELETE_EVENTS_RESPONSE`,
);

export const ROUTE_BULK_REMOVE_EVENTS = createAction(
  `${moduleName}/ROUTE_BULK_REMOVE_EVENTS`,
);

export const navigateToBulkRemoveEvents = createAction(
  ROUTE_BULK_REMOVE_EVENTS.type,
);

/** For single person select, see  `selectEventPerson` */
export const selectMultipleEventPerson = createAction<{ userIds: number[] }>(
  `${moduleName}/SELECT_MULTIPLE_EVENT_PERSON` as const,
);
